import React from 'react'
import { Select } from 'antd'
const { Option } = Select;
const SelectTemplate = ({ templateName, HandleTemplate, templateList }) => {
    const approvedTemplates = templateList?.filter(item => item.status === "APPROVED") || [];
    const hasTemplates = approvedTemplates.length > 0;

    return (
        <Select
            size="default"
            value={templateName || undefined}
            style={{ width: '100%' }}
            onChange={(value) => HandleTemplate(value)}
            showSearch
            placeholder={hasTemplates ? "Select" : "You Don't Have Any Approved Templates"}
            notFoundContent="You Don't Have Any Approved Templates"
        >
            <Option value="choose...">select</Option>
            {approvedTemplates.map((item, index) => (
                <Option value={item.name} key={index}>
                    {item.name}
                </Option>
            ))}
        </Select>
    )
}

export default SelectTemplate
